import styled, { css } from 'styled-components'

import { device } from '~/styles/device'

import Tooltip from '../_elements/Tooltip'

export const IconWrapper = styled.div`
  ${({ theme }) => css`
    &.success {
      color: ${theme.colors.success};
    }
    &.error {
      color: ${theme.colors.danger};
    }
  `}
`

const containerAttrs = () => ({
  className: 'inputContainer'
})

type ContainerProps = {
  minHeightTextarea?: string | number
  isErrored?: boolean
  isDisabled?: boolean
  showWarning?: boolean
}

export const Container = styled.div.attrs(containerAttrs)<ContainerProps>`
  ${({
    minHeightTextarea,
    isErrored = false,
    isDisabled = false,
    showWarning
  }) => css`
    --minWidth: 100px;

    @media ${device.laptop} {
      --minWidth: 2rem;
    }

    background: var(--sl-bg-base, #ffffff);
    min-height: 2.75rem;
    width: 100%;
    font: var(--sl-text-body-font);
    letter-spacing: var(--sl-text-body-letter-spacing);
    border-radius: var(--sl-radius-2);
    display: flex;
    align-items: center;
    border: var(--sl-border-base-strong);

    min-width: var(--minWidth);
    transition: 0.3s border-color ease-in-out;

    &:focus-within {
      box-shadow: var(--sl-focus-ring-base);
      border: var(--sl-border-base-strong-hover);
    }

    ${isErrored &&
    css`
      border: var(--sl-border-critical-strong);

      &:hover {
        border: var(--sl-border-critical-strong-hover);
      }
      &:focus-within {
        box-shadow: var(--sl-focus-ring-critical);
        border: var(--sl-border-critical-strong-hover);
      }
    `}

    ${isDisabled &&
    css`
      border: var(--sl-border-base-disabled);
      color: var(--sl-fg-base-disabled);
      background-color: var(--sl-bg-base-disabled);
    `}

    ${showWarning &&
    css`
      border-color: var(--sl-color-orange-9);
      > svg {
        color: var(--sl-color-orange-9);
      }
    `}

    & + div {
      margin-top: 0.5rem;
    }

    input {
      padding-left: var(--sl-space-4);
      padding-right: var(--sl-space-4);
      width: 100%;
      height: 100%;
      border: none;
      background-color: unset;
      border-radius: var(--sl-radius-2);

      max-width: 100%;
      min-width: var(--minWidth);
      flex: 1;

      &::placeholder {
        color: var(--gray) !important;
      }

      &:focus {
        outline: none;
      }

      &:-webkit-autofill {
        -webkit-box-shadow: 0 0 0 30px var(--white) inset;
      }
    }

    textarea {
      padding: var(--sl-space-3) var(--sl-space-4);
      background: transparent;
      color: var(--dark);
      flex: 1;
      border: 0;
      max-width: 100%;
      min-width: 2rem;
      min-height: ${minHeightTextarea || '10rem'};
      resize: none;
      border-radius: var(--sl-radius-2);

      &::placeholder {
        color: var(--gray) !important;
      }

      &:focus {
        outline: none;
      }

      &:-webkit-autofill {
        -webkit-box-shadow: 0 0 0 30px var(--white) inset;
      }
    }

    select {
      width: 100%;
      margin: 0.75rem 1rem;
      border: none;
      background-color: transparent;

      &:focus {
        outline: none;
      }
    }

    > svg {
      margin-left: 0.5rem;
      transition: 0.2s all;
      font-size: 1.5rem;
    }

    > .rightElement {
      margin-right: var(--sl-space-4);
    }

    > .htmlIcon,
    > .htmlRightIcon {
      padding: var(--sl-space-3) var(--sl-space-4);
      height: 100%;
      align-items: center;
      display: flex;
    }

    > .htmlIcon {
      border-right: var(--sl-border-base);
    }

    > .htmlRightIcon {
      border-left: var(--sl-border-base);
    }
  `}
`

export const Error = styled(Tooltip)`
  line-height: 1rem;
  height: 1rem;
  margin-left: 1rem;

  --mainColor: var(--danger);
  --mainColorText: var(--white);
`
export const MessageError = styled.div`
  color: var(--sl-fg-critical);
  font-size: 0.75rem;
  margin-bottom: 0.5rem;
`

export const MessageHelp = styled.div`
  color: var(--sl-fg-base-soft);
  font-size: 0.75rem;
  margin-bottom: 0.5rem;
`
